import Template from '../../component/Template.js';
import { ToastContainer } from 'react-toastify';
import '../../Assets/css/vendors/bootstrap.css';

function Home() {
    return (
        <>
            <ToastContainer />
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="table-responsive">
                            <div className="card">
                                <div className="col-md-12">
                                    <div className="card-header">
                                        <div className="py-3 d-flex justify-content-between align-items-center">
                                            <h5>Studen List</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div className='row'>
                                                <div className='col-md-6 wdt'>
                                                    <p>
                                                    Showing -  of entries
                                                    </p>
                                                </div>
                                                <div className='col-md-6 wdt' align='right'>
                                                    <input
                                                    type="text"
                                                    value=""
                                                    onChange="s"
                                                    placeholder="Search..."
                                                    className='form-control'
                                                    />
                                                </div>
                                                <div class="table-containerq" style={{ overflowX: 'unset' }}>
                                                    <table className="display dataTable table-striped table-bordered ex-v-table ">
                                                        <thead>
                                                            <tr className="bg-primary">
                                                                <th scope="col" data-label="" width="8%">Sl No</th>
                                                                <th scope="col" data-label="PRN" width="">PRN</th>
                                                                <th scope="col" data-label="APAAR ID" width="">APAAR ID</th>
                                                                <th scope="col" data-label="Name" width="">Name</th>
                                                                <th scope="col" data-label="Topic" width="">Topic</th>
                                                                <th scope="col" data-label="CCA" width="">CCA</th>
                                                                <th scope="col" data-label="ESE" width="">ESE</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <style>{`
                .togl-sec-2btn, .togl-sec{
                    cursor: default !important;
                }
        
                .switch-loading .slider {
                    background: linear-gradient(90deg, #cbd5e0 0%, #a0aec0 50%, #cbd5e0 100%) !important;
                    background-size: 200% 100%;
                    animation: shimmer 1.5s ease-in-out infinite;
                    opacity: 0.7;
                    cursor: not-allowed;
                }
        
                .switch-loading .slider:before {
                    opacity: 0.5;
                }
        
                @keyframes shimmer {
                    0% {
                    background-position: 200% 0;
                    }
                    100% {
                    background-position: -200% 0;
                    }
                }
        
                .switch-loading {
                    animation: pulse 2s ease-in-out infinite;
                }
        
                @keyframes pulse {
                    0%, 100% {
                    opacity: 1;
                    }
                    50% {
                    opacity: 0.8;
                    }
                }
                `}</style>
            </Template >
        </>
    );
}

export default Home;